/**
 * * Магическая хуйня
 */
import Middleware from './middleware'

import AuthMiddleware from '~shop/auth/middleware'
import plugin from '~shop/plugin'

Middleware.auth = AuthMiddleware

export default plugin
